import { render } from "./SectionSLide.vue?vue&type=template&id=07f7c027&scoped=true"
import script from "./SectionSLide.vue?vue&type=script&lang=js"
export * from "./SectionSLide.vue?vue&type=script&lang=js"

import "./SectionSLide.vue?vue&type=style&index=0&id=07f7c027&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f7c027"]])

export default __exports__